import { BLUR_CLASS, DIRECTION_DOWN_CLASS, DIRECTION_UP_CLASS, SCROLL_CLASS } from '../utils/classes';
import React, { useState, useEffect } from "react";
import * as b from "./bootstrap.module.css";
import { graphql, Link, useStaticQuery } from "gatsby";
import ThemeToggle from './theme-toggle';
import resolveUrl from '../utils/urls/resolve-url';

import NonBankLoanNavigation from './top-navigation/non-bank-loan-navigation';
import CreditNavigation from './top-navigation/credit-navigation';
import AccountNavigation from './top-navigation/account-navigation';

const Header = () => {
  const { categories } = useStaticQuery(graphql`
    query Header {
      categories: allMysqlTerms(filter: {menu: {glob: "*header*"}, cluster: {ne: "menu"}, menu_parent: {eq: 0}}, sort: {fields: sort, order: ASC}) {
        nodes {
          term
          term_normalized
          path
          cluster
        }
      }
    }
  `);

  const [activeNavigation, setActiveNavigation] = useState('');
  const [activeMobileNavigation, setActiveMobileNavigation] = useState(false);

  const offAll = () => {
    setActiveNavigation('');
    setActiveMobileNavigation(false);
  };
  const forceOffAll = (e) => {
    if (e.target.nodeName === 'A' && e.target.getAttribute('aria-current') === 'page') {
      offAll();
    }
  };
  const toggler = () => setActiveMobileNavigation(!activeMobileNavigation);
  const changeNavigation = (cluster) => setActiveNavigation(activeNavigation !== cluster ? cluster :  '');

  useEffect(() => {
    document.body.classList.toggle(BLUR_CLASS, activeNavigation);
    document.body.classList.toggle(SCROLL_CLASS, activeNavigation);
  }, [activeNavigation]);

  useEffect(() => {
    document.body.classList.toggle(SCROLL_CLASS, activeMobileNavigation);

    if (!activeMobileNavigation) {
      offAll();
    }
  }, [activeMobileNavigation]);

  useEffect(() => {
    let oldPosY = window.scrollY;
    let timeoutID;
    const position = () => {
      clearTimeout(timeoutID);

      if (window.scrollY < 400) {
        document.body.classList.add(DIRECTION_UP_CLASS);
        document.body.classList.remove(DIRECTION_DOWN_CLASS);

        oldPosY = window.scrollY;

        return;
      }
      
      if (document.body.classList.contains(SCROLL_CLASS)) {
        document.body.classList.add(DIRECTION_DOWN_CLASS);
        document.body.classList.remove(DIRECTION_UP_CLASS);

        oldPosY = window.scrollY;

        return;
      }
  
      timeoutID = setTimeout(() => {
        const result = oldPosY - window.scrollY >= 0;

        document.body.classList.toggle(DIRECTION_UP_CLASS, result);
        document.body.classList.toggle(DIRECTION_DOWN_CLASS, !result);

        oldPosY = window.scrollY;
      }, 100);
    };

    window.addEventListener('scroll', position, { passive: true });

    return () => window.removeEventListener('scroll', position);
  }, []);

  return (
    <header 
      onClickCapture={forceOffAll} 
      className={`header ${activeNavigation || activeMobileNavigation ? 'open' : ''} ${activeNavigation ? 'active-navigation' : ''}`}
    >
      <div className={b.container}>
        <div className={`${b.row} ${b.alignItemsCenter}`}>
          <div className={`${b.col} ${b.colLgAuto}`}>
            <Link onClick={offAll} to="/" className="header-logo" aria-label="Logotyp serwisu Ofin.pl">
              <svg width="94" height="35" viewBox="0 0 94 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_9927_167983)">
                  <path d="M46.33 18.9124C46.33 17.7408 46.6049 16.6968 47.1549 15.7803C47.7049 14.8639 48.4585 14.1401 49.4131 13.6141C50.3676 13.0882 51.457 12.8226 52.6786 12.8226C53.9002 12.8226 54.9843 13.0856 55.9362 13.6141C56.8881 14.1427 57.6391 14.8639 58.1891 15.7803C58.7391 16.6968 59.0141 17.7408 59.0141 18.9124C59.0141 20.084 58.7391 21.1281 58.1891 22.0445C57.6391 22.961 56.8881 23.6848 55.9362 24.2107C54.9843 24.7367 53.8976 25.0022 52.6786 25.0022C51.4597 25.0022 50.3703 24.7393 49.4131 24.2107C48.4585 23.6848 47.7049 22.961 47.1549 22.0445C46.6049 21.1281 46.33 20.084 46.33 18.9124ZM49.659 18.9124C49.659 19.8185 49.9445 20.5709 50.5157 21.1723C51.0868 21.7738 51.8087 22.0732 52.6813 22.0732C53.5538 22.0732 54.2757 21.7738 54.8442 21.1723C55.4153 20.5709 55.7009 19.8185 55.7009 18.9124C55.7009 18.0064 55.4153 17.2539 54.8442 16.6525C54.2731 16.0511 53.5512 15.7517 52.6813 15.7517C51.8113 15.7517 51.0868 16.0511 50.5157 16.6525C49.9445 17.2539 49.659 18.0064 49.659 18.9124Z" fill="#0D2181" />
                  <path d="M61.5498 13.0596V11.4792C61.5498 10.5263 61.7587 9.71397 62.1791 9.04485C62.5996 8.37313 63.1548 7.86022 63.845 7.50613C64.5351 7.15204 65.2808 6.9724 66.0819 6.9724C66.6055 6.9724 67.1343 7.0505 67.6684 7.20672C68.2026 7.36293 68.7235 7.60507 69.2312 7.93312L67.9117 10.3102C67.7134 10.1462 67.5045 10.0368 67.2824 9.98214C67.0603 9.92747 66.8593 9.90143 66.6769 9.90143C66.1692 9.90143 65.7594 10.0681 65.4473 10.3987C65.1327 10.7294 64.9767 11.2449 64.9767 11.9374V13.0622H67.8668V15.9886H64.9767V24.7705H61.5525V15.986H59.5905V13.0596H61.5525H61.5498Z" fill="#0D2181" />
                  <path d="M69.4348 9.0787C69.4348 8.51632 69.6093 8.0633 69.9583 7.71963C70.3073 7.37595 70.7674 7.20412 71.3386 7.20412C71.9097 7.20412 72.3698 7.37595 72.7188 7.71963C73.0678 8.0633 73.2424 8.51632 73.2424 9.0787C73.2424 9.64107 73.0678 10.0941 72.7188 10.4378C72.3698 10.7814 71.9097 10.9533 71.3386 10.9533C70.7674 10.9533 70.3073 10.7814 69.9583 10.4378C69.6093 10.0941 69.4348 9.64107 69.4348 9.0787ZM69.6251 24.7679V13.0596H73.0493V24.7679H69.6251Z" fill="#0D2181" />
                  <path d="M75.4661 24.7679V13.0596H78.462L78.6047 14.489C79.0728 13.9578 79.6333 13.5491 80.2891 13.2601C80.9422 12.9711 81.6614 12.8279 82.4467 12.8279C83.8349 12.8279 84.9402 13.2783 85.7652 14.1791C86.5902 15.08 87.0026 16.3349 87.0026 17.9439V24.7705H83.5652V18.6C83.5652 16.702 82.8434 15.7543 81.3996 15.7543C80.654 15.7543 80.0511 16.0225 79.5857 16.5614C79.1204 17.1003 78.8903 17.858 78.8903 18.8317V24.7679H75.4661Z" fill="#0D2181" />
                  <path d="M24.3278 20.5865H22.7175C21.3795 20.5865 20.2769 21.6696 20.2769 22.9897V27.7933C20.2769 29.1107 21.3769 30.1964 22.7175 30.1964V25.3928H22.9184C23.6958 25.3928 24.3278 24.7705 24.3278 24.0051V20.5892V20.5865Z" fill="#0D2181" />
                  <path d="M24.3278 31.5815V34.9974H25.9381V30.1938H25.7371C24.9597 30.1938 24.3278 30.816 24.3278 31.5815Z" fill="#00E5B1" />
                  <path d="M28.3786 27.7933C28.3786 26.4759 27.2787 25.3902 25.9407 25.3902V30.1938V34.9948C27.2787 34.9948 28.3786 33.9117 28.3786 32.5943V27.7933Z" fill="#00E5B1" />
                  <path d="M30.5257 22.9272L30.6262 22.7553C31.0149 22.0914 30.7849 21.2427 30.1106 20.8599L27.1068 19.152L26.3003 20.5267C25.6314 21.667 26.0333 23.1485 27.1941 23.8072L31.4195 26.2103C32.5776 26.869 34.0821 26.4733 34.7511 25.3303L32.6384 24.13L30.5257 22.9298V22.9272Z" fill="#0D2181" />
                  <path d="M38.4741 23.7811L40.5868 24.9814C41.2558 23.841 40.8539 22.3596 39.6931 21.7009L35.4703 19.3004C34.3122 18.6417 32.8076 19.0374 32.1387 20.1804L34.2514 21.3806L36.3641 22.5809L38.4741 23.7811Z" fill="#00E5B1" />
                  <path d="M36.2609 22.7553C35.8722 23.4193 36.1023 24.268 36.7766 24.6508L39.7803 26.3587L40.5868 24.984L36.3614 22.5809L36.2609 22.7527V22.7553Z" fill="#00E5B1" />
                  <path d="M28.0402 17.4388C28.7092 18.5792 30.2137 18.9775 31.3719 18.3188L35.5973 15.9157C36.7554 15.257 37.16 13.7756 36.491 12.6352L34.3783 13.8354L32.2656 15.0357L32.1651 14.8639C31.7764 14.1999 30.9144 13.9734 30.2402 14.3562L27.2364 16.0641L28.0428 17.4388" fill="#0D2181" />
                  <path d="M39.1034 7.4853L34.878 9.88581L34.9785 10.0576C35.3672 10.7216 36.2292 10.9481 36.9035 10.5653L39.9073 8.85739L39.1008 7.4827L39.1034 7.4853Z" fill="#00E5B1" />
                  <path d="M36.9907 8.68556L39.1034 7.4853C38.4345 6.34493 36.9299 5.94919 35.7718 6.60529L31.549 9.0058C30.3909 9.6645 29.9863 11.1459 30.6553 12.2863L32.768 11.0861L34.8807 9.88581L36.9907 8.68556Z" fill="#00E5B1" />
                  <path d="M24.5816 14.4109H26.1919C27.5299 14.4109 28.6325 13.3278 28.6325 12.0077V7.20673C28.6325 5.88931 27.5325 4.80362 26.1919 4.80362V9.60724H25.991C25.2136 9.60724 24.5816 10.2295 24.5816 10.9949V14.4109Z" fill="#0D2181" />
                  <path d="M22.9713 0V4.80362H23.1749C23.9523 4.80362 24.5843 4.18136 24.5843 3.4159V0H22.974H22.9713Z" fill="#FC6262" />
                  <path d="M22.9687 2.40324V0.00273132C21.6307 0.00273132 20.5307 1.08582 20.5307 2.40324V7.20425C20.5307 8.52166 21.6307 9.60736 22.9713 9.60736V4.80374V2.40324H22.9687Z" fill="#FC6262" />
                  <path d="M22.6091 14.4733C23.278 13.333 22.8761 11.8515 21.7153 11.1928L17.4899 8.78971C16.3318 8.131 14.8273 8.52674 14.1583 9.66972L16.271 10.87L18.3837 12.0702L18.2832 12.2421C17.8945 12.906 18.1245 13.7547 18.7988 14.1375L21.8026 15.8454L22.6091 14.4707" fill="#0D2181" />
                  <path d="M12.1328 10.3492L9.12906 8.6413L8.32259 10.016L12.548 12.4191L12.6485 12.2473C13.0371 11.5833 12.8071 10.7346 12.1328 10.3519V10.3492Z" fill="#00E5B1" />
                  <path d="M13.4391 15.697C14.5972 16.3557 16.1017 15.96 16.7707 14.817L14.658 13.6167L12.5453 12.4165L10.4353 11.2162L8.32258 10.016C7.65361 11.1564 8.05552 12.6378 9.21631 13.2965L13.4391 15.697Z" fill="#00E5B1" />
                  <path d="M20.8692 17.5612C20.2002 16.4208 18.6957 16.0225 17.5375 16.6812L13.3121 19.0843C12.154 19.743 11.7494 21.2244 12.4184 22.3648L14.5311 21.1645L16.6438 19.9643L16.7443 20.1361C17.133 20.8 17.995 21.0266 18.6692 20.6438L21.673 18.9359L20.8666 17.5612H20.8692Z" fill="#0D2181" />
                  <path d="M12.0059 24.432L9.00214 26.14L9.80861 27.5147L14.034 25.1116L13.9335 24.9397C13.5448 24.2758 12.6828 24.0493 12.0086 24.432H12.0059Z" fill="#00E5B1" />
                  <path d="M16.1414 23.9113L14.0287 25.1116L11.9187 26.3118L9.80597 27.5121C10.4749 28.6525 11.9795 29.0482 13.1376 28.3921L17.3604 25.9916C18.5185 25.3329 18.9231 23.8514 18.2541 22.7111L16.1414 23.9113Z" fill="#00E5B1" />
                </g>
                <defs>
                  <clipPath id="clip0_9927_167983">
                    <rect width="79" height="35" fill="white" transform="translate(8)" />
                  </clipPath>
                </defs>
              </svg>
            </Link>
          </div>
          
          <ThemeToggle />

          <div className={`top-navigation-list-wrapper ${b.colAuto} ${b.colLg} ${b.dNone} ${b.dLgFlex} ${b.justifyContentEnd} ${b.px0}`}>
            <div className={`${b.container} ${b.prLg0}`}>
              <ul className="top-navigation-list blackToWhite">
                {categories.nodes.map((category, i) => (
                  <li key={i}>
                    <button 
                      onClick={() => changeNavigation(category.cluster)}
                      className={category.cluster === activeNavigation ? 'active' : ''}
                    >{category.term}</button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className={`${b.colAuto} ${b.pl0} ${b.dLgNone} cursor-pointer`}>
            <button onClick={toggler} className={["header-toggle","header-btn", b.ml3].join(' ')} aria-label='menu'>
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>

      <nav className="top-navigation">
        <div id="top-navigation-scroll" className={b.container}>
          <NonBankLoanNavigation activeNavigation={activeNavigation} changeNavigation={changeNavigation} />
          <CreditNavigation activeNavigation={activeNavigation} changeNavigation={changeNavigation} />
          <AccountNavigation activeNavigation={activeNavigation} changeNavigation={changeNavigation} />
        </div>
      </nav>

      <button className="header-hidden-btn" onClick={offAll}>&nbsp;</button>
    </header>
  );
};

export default Header
